import styles from "./Card.module.scss";

interface Props {
  children: React.ReactNode,
  className?: string,
}

export function Card({ children, className }: Props) {
  return (
    <section className={`${styles.Card} ${className}`}>
      {children}
    </section>
  )
}
